import { Radio, Select } from "antd";
import { DatePicker } from "antd-mobile";
import moment from "moment";
import React, { useEffect, useState, useContext } from "react";
import { contexData } from "@/store";
import "./index.less";
import { parseInt, last, first } from "lodash"; 

import { getDesc } from "@/utils/common";
import { language } from "@/utils/language";



// import enUs from "antd-mobile/lib/date-picker/locale/en_US";
const { Option } = Select;

const nowTimeStamp = Date.now();
// GMT is not currently observed in the UK. So use UTC now.
const isMobile = /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);

// Make sure that in `time` mode, the maxDate and minDate are within one day.
let minDate = new Date(nowTimeStamp - 1e7);
const maxDate = new Date(nowTimeStamp + 1e7);
if (minDate.getDate() !== maxDate.getDate()) {
  // set the minDate to the 0 of maxDate
  minDate = new Date(
    maxDate.getFullYear(),
    maxDate.getMonth(),
    maxDate.getDate()
  );
}

// 年龄题
export default function Age(props) {
  const { answer, info = {}, changeAnswer } = props;

  const { options } = info;
  const [_info, set_info] = useState(info);
  const [visible, setVisible] = useState(false);
  const [dpValue, setdpValue] = useState("");
  const [currentItemObj, setcurrentItemObj] = useState({});
  const [olddate, setOlddate] = useState("");

  const DATEPICKERTYPE = ["date", "year", "month", "date"];
  const FORMATTYPE = ["YYYY-MM-DD", "YYYY", "YYYY-MM", "YYYY-MM-DD"];

  // 点击选项
  const onRadioClick = (val, index, item) => {
    setcurrentItemObj(item);

    set_info({ ..._info, isRadio: val });
  };

  const [postDataPc, setpostDataPc] = useState({
    year: "",
    month: "",
    day: "",
  });

  const [pcSelctData, setpcSelctData] = useState([]);

  // 显示上一题答案
  useEffect(() => {

    try {

      if (answer.model === "age") {
        let _answer = answer;
        if (!_answer[info.id]) return
        let get_id = Object.keys(_answer[info.id])[0];
        if (isMobile) {
          let strTime = _answer[info.id][get_id].text; //字符串日期格式
          let date = new Date(Date.parse(strTime.replace(/-/g, "/"))); //转换成Data();
          if (isMobile) {
            date = new Date(Date.parse(strTime));
          }
          // setOlddate1(Date.parse(strTime))
          info.options.forEach((item) => {
            if (item.id === get_id) {
              setcurrentItemObj({ ...item });
              setdpValue(date);
              set_info({ ..._info, isRadio: item.ageDescription });
            }
          });
        } else {
          let _answer = answer;
          if (!_answer[info.id]) return
          let get_id = Object.keys(_answer[info.id])[0];

          let selcTime = _answer[info.id][get_id].text.split("-");
          info.options.forEach((item) => {
            if (item.id === get_id) {
              item.isRadio = true;
              setOlddate(selcTime);
              setcurrentItemObj(() => {
                // _onChange(selcTime[1], 0, pcSelctData[0]);
                return { ...item };
              });
            } else {
              item.isRadio = false;
            }
          });
        }
      }
    } catch (error) { }
  }, [answer]);

  useEffect(() => {
    let list = [
      {
        isshow: true,
        options: calculateAge(currentItemObj.ageDescription, _info.ageType),
        defaultValue: language().select_year,
        value: olddate[0],
        type: "year",
      },
      {
        isshow: info.ageType !== 1,
        options: [],
        defaultValue: language().select_month,
        value: olddate[1],
        type: "month",
      },
      {
        isshow: info.ageType !== 1 && info.ageType !== 2,
        options: [],
        value: olddate[2],
        defaultValue: language().select_date,
        type: "day",
      },
    ];

    try {
      let _answer = answer;
      if (!_answer[info.id]) return
      let get_id = Object.keys(_answer[info.id])[0];
      let selcTime = _answer[info.id][get_id].text.split("-");
      if (selcTime.length === 3) {
        let _days = sessionStorage.getItem("_days");
        list[2].options = JSON.parse(_days);
      }
    } catch (error) { }
    setpcSelctData([...list]);

  }, [currentItemObj.ageDescription, info.ageType]);

  useEffect(() => {
    if (answer.model === "age") {
      let _answer = answer;
      if (!_answer[info.id]) return
      let get_id = Object.keys(_answer[info.id])[0];
      let selcTime = _answer[info.id][get_id].text.split("-");

      if (!isMobile) {

        _onChange(selcTime[0], 0, pcSelctData[0]);
        changeAnswer(
          _answer[info.id],
          _answer[info.id][get_id].text
        );
      } else {
        changeAnswer(
          _answer[info.id],
          _answer[info.id][get_id].text
        );
      }

    }
  }, [pcSelctData]);

  const _onChange = (e, index, item, click) => {


    const date = new Date();
    const getFullYear = date.getFullYear();
    const getMonth = date.getMonth() + 1;
    const getDate = date.getDate();
    if (_info.ageType == 1) {
      if (item.type === "year") {
        postDataPc.year = "" + e;
        if (click) {
          pcSelctData[1].value = undefined;
          pcSelctData[2].value = undefined;
          pcSelctData[2].options = [];
          // pcSelctData[1].options
        }

        let allmonth = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        if (e == getFullYear) {
          pcSelctData[1].options = allmonth.filter((item) => item <= getMonth);
        } else {
          let date = getAgeMatch(currentItemObj.ageDescription, 2);
          // let _age = getAgeMatch(strValue, 1);

          let ageList = calculateAge(
            currentItemObj.ageDescription,
            _info.ageType
          );

          if (e == ageList[0]) {
            if (date.includes("-")) {
              pcSelctData[1].options = allmonth.filter(
                (item) => item <= getMonth
              );
            } else if (date.includes("&gt;")) {
              if (date.includes("&gt;=")) {
                pcSelctData[1].options = allmonth.filter(
                  (item) => item <= getMonth
                );
              } else {
                pcSelctData[1].options = allmonth.filter(
                  (item) => item > getMonth
                );
              }
            }
          } else if (e == ageList[ageList.length - 1]) {
            if (date.includes("&lt;")) {
              if (date.includes("&lt;=")) {

                pcSelctData[1].options = allmonth.filter(
                  (item) => item > getMonth
                );
              } else {
                if (new Date().getMonth() === 11) {
                  pcSelctData[1].options = allmonth;
                } else {
                  pcSelctData[1].options = allmonth.filter(
                    (item) => item > getMonth
                  );
                }
              }
            } else if (date.includes("-")) {
              pcSelctData[1].options = allmonth.filter(
                (item) => item > getMonth
              );
              if (pcSelctData[1].options.length == 0) {
                pcSelctData[1].options = allmonth;
              }
            } else if (date.includes("&gt;")) {
              if (date.includes("&gt;=")) {
                if (new Date().getMonth() === 11) {
                  pcSelctData[1].options = allmonth;
                } else {
                  pcSelctData[1].options = allmonth.filter(
                    (item) => item > getMonth
                  );
                }
              } else {
                if (new Date().getMonth() === 11) {
                  pcSelctData[1].options = allmonth;
                } else {
                  pcSelctData[1].options = allmonth.filter(
                    (item) => item > getMonth
                  );
                }
              }
            }
          } else {
            pcSelctData[1].options = allmonth;
            // pcSelctData[1].value = allmonth;
          }
        }
        console.log('222', pcSelctData);

      } else if (item.type === "month") {
        if (click) {
          pcSelctData[2].value = undefined;
          pcSelctData[2].options = [];
          // pcSelctData[1].options
        }
        postDataPc.month = e + "";
        const currentdays = getDaysInMonth(postDataPc.year, postDataPc.month);

        if (postDataPc.year === getFullYear && getMonth === e) {
          pcSelctData[2].options = currentdays.filter((item) => item <= getDate);
        } else {
          ///////////处理天
          // if (date.includes("-")) {
          // }
          // 精确天的计算

          if (
            postDataPc.year === pcSelctData[0].options[0] &&
            postDataPc.month ===
            pcSelctData[1].options[pcSelctData[1].options.length - 1]
          ) {
            pcSelctData[2].options = currentdays.filter(
              (item) => item <= getDate
            );
          } else if (
            postDataPc.year ===
            pcSelctData[0].options[pcSelctData[0].options.length - 1] &&
            postDataPc.month === pcSelctData[1].options[0]
          ) {
            let _days = currentdays.filter((item3) => item3 > getDate);
            pcSelctData[2].options = _days;
          } else {

            let yearLast = last(pcSelctData[0].options);
            let yearFirst = first(pcSelctData[0].options);
            pcSelctData[2].options = currentdays;
            if (postDataPc.year == yearLast && postDataPc.month == getMonth) {
              pcSelctData[2].disabledDate = 'before';
            } else if (postDataPc.year == yearFirst && postDataPc.month == getMonth) {
              pcSelctData[2].disabledDate = 'after';
            } else {
              //  天数
              pcSelctData[2].disabledDate = false;
            }
          }
          sessionStorage.setItem("_days", JSON.stringify(pcSelctData[2].options));
        }

      } else if (item.type === "day") {
        postDataPc.day = e;
      }

    } else if (_info.ageType == 2) {
      if (item.type === "year") {
        postDataPc.year = "" + e;
        if (click) {
          pcSelctData[1].value = undefined;
          pcSelctData[2].value = undefined;
          pcSelctData[2].options = [];
          // pcSelctData[1].options
        }

        let allmonth = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        if (e == getFullYear) {
          pcSelctData[1].options = allmonth.filter((item) => item <= getMonth);
        } else {
          let date = getAgeMatch(currentItemObj.ageDescription, 2);

          // let date = currentItemObj.ageDescription
          //   ?.replace("<p>", "")
          //   ?.replace("</p>", "");
          let ageList = calculateAge(
            currentItemObj.ageDescription,
            _info.ageType
          );

          if (e == ageList[0]) {
            if (date.includes("-")) {
              pcSelctData[1].options = allmonth.filter(
                (item) => item <= getMonth
              );
            } else if (date.includes("&gt;")) {
              if (date.includes("&gt;=")) {
                pcSelctData[1].options = allmonth.filter(
                  (item) => item <= getMonth
                );
              } else {
                pcSelctData[1].options = allmonth.filter(
                  (item) => item > getMonth
                );
              }
            }
          } else if (e == ageList[ageList.length - 1]) {
            if (date.includes("&lt;")) {

              if (date.includes("&lt;=")) {

                pcSelctData[1].options = allmonth.filter(
                  (item) => item > getMonth
                );
              } else {
                if (new Date().getMonth() === 11) {
                  pcSelctData[1].options = allmonth;
                } else {
                  pcSelctData[1].options = allmonth.filter(
                    (item) => item > getMonth
                  );
                }
              }
            } else if (date.includes("-")) {
              pcSelctData[1].options = allmonth.filter(
                (item) => item > getMonth
              );
              if (pcSelctData[1].options.length == 0) {
                pcSelctData[1].options = allmonth;
              }
            } else if (date.includes("&gt;")) {
              if (date.includes("&gt;=")) {
                if (new Date().getMonth() === 11) {
                  pcSelctData[1].options = allmonth;
                } else {
                  pcSelctData[1].options = allmonth.filter(
                    (item) => item > getMonth
                  );
                }
              } else {
                if (new Date().getMonth() === 11) {
                  pcSelctData[1].options = allmonth;
                } else {
                  pcSelctData[1].options = allmonth.filter(
                    (item) => item > getMonth
                  );
                }
              }
            }
          } else {
            pcSelctData[1].options = allmonth;
            // pcSelctData[1].value = allmonth;
          }
        }
        console.log('222', pcSelctData);

      } else if (item.type === "month") {
        if (click) {
          pcSelctData[2].value = undefined;
          pcSelctData[2].options = [];
          // pcSelctData[1].options
        }
        postDataPc.month = e + "";
        const currentdays = getDaysInMonth(postDataPc.year, postDataPc.month);

        if (postDataPc.year === getFullYear && getMonth === e) {
          pcSelctData[2].options = currentdays.filter((item) => item <= getDate);
        } else {
          ///////////处理天
          // if (date.includes("-")) {
          // }
          // 精确天的计算

          if (
            postDataPc.year === pcSelctData[0].options[0] &&
            postDataPc.month ===
            pcSelctData[1].options[pcSelctData[1].options.length - 1]
          ) {
            pcSelctData[2].options = currentdays.filter(
              (item) => item <= getDate
            );
          } else if (
            postDataPc.year ===
            pcSelctData[0].options[pcSelctData[0].options.length - 1] &&
            postDataPc.month === pcSelctData[1].options[0]
          ) {
            let _days = currentdays.filter((item3) => item3 > getDate);
            pcSelctData[2].options = _days;
          } else {

            let yearLast = last(pcSelctData[0].options);
            let yearFirst = first(pcSelctData[0].options);
            pcSelctData[2].options = currentdays;
            if (postDataPc.year == yearLast && postDataPc.month == getMonth) {
              pcSelctData[2].disabledDate = 'before';
            } else if (postDataPc.year == yearFirst && postDataPc.month == getMonth) {
              pcSelctData[2].disabledDate = 'after';
            } else {
              //  天数
              pcSelctData[2].disabledDate = false;
            }
          }
          sessionStorage.setItem("_days", JSON.stringify(pcSelctData[2].options));
        }

      } else if (item.type === "day") {
        postDataPc.day = e;
      }
    } else {
      if (item.type === "year") {
        postDataPc.year = "" + e;
        if (click) {
          pcSelctData[1].value = undefined;
          pcSelctData[2].value = undefined;
          pcSelctData[2].options = [];
          // pcSelctData[1].options
        }

        let allmonth = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        if (e == getFullYear) {
          pcSelctData[1].options = allmonth.filter((item) => item <= getMonth);
        } else {
          let date = getAgeMatch(currentItemObj.ageDescription, 2);

          // let date = currentItemObj.ageDescription
          //   ?.replace("<p>", "")
          //   ?.replace("</p>", "");

          let ageList = calculateAge(
            currentItemObj.ageDescription,
            _info.ageType
          );

          if (e == ageList[0]) {
            if (date.includes("-")) {
              pcSelctData[1].options = allmonth.filter(
                (item) => item <= getMonth
              );
            } else if (date.includes("&gt;")) {
              if (date.includes("&gt;=")) {
                pcSelctData[1].options = allmonth.filter(
                  (item) => item <= getMonth
                );
              } else {
                pcSelctData[1].options = allmonth.filter(
                  (item) => item > getMonth
                );
              }
            }
          } else if (e == ageList[ageList.length - 1]) {
            if (date.includes("&lt;")) {

              if (date.includes("&lt;=")) {

                pcSelctData[1].options = allmonth.filter(
                  (item) => item >= getMonth
                );
              } else {
                if (new Date().getMonth() === 11) {
                  pcSelctData[1].options = allmonth;
                } else {
                  pcSelctData[1].options = allmonth.filter(
                    (item) => item > getMonth
                  );
                }
              }
            } else if (date.includes("-")) {
              pcSelctData[1].options = allmonth.filter(
                (item) => item >= getMonth
              );
              if (pcSelctData[1].options.length == 0) {
                pcSelctData[1].options = allmonth;
              }
            } else if (date.includes("&gt;")) {
              if (date.includes("&gt;=")) {
                if (new Date().getMonth() === 11) {
                  pcSelctData[1].options = allmonth;
                } else {
                  pcSelctData[1].options = allmonth.filter(
                    (item) => item > getMonth
                  );
                }
              } else {
                if (new Date().getMonth() === 11) {
                  pcSelctData[1].options = allmonth;
                } else {
                  pcSelctData[1].options = allmonth.filter(
                    (item) => item > getMonth
                  );
                }
              }
            }
          } else {
            pcSelctData[1].options = allmonth;
            // pcSelctData[1].value = allmonth;
          }
        }
      } else if (item.type === "month") {
        if (click) {
          pcSelctData[2].value = undefined;
          pcSelctData[2].options = [];
          // pcSelctData[1].options
        }
        postDataPc.month = e + "";
        const currentdays = getDaysInMonth(postDataPc.year, postDataPc.month);

        if (postDataPc.year === getFullYear && getMonth === e) {
          pcSelctData[2].options = currentdays.filter((item) => item <= getDate);
        } else {
          ///////////处理天
          // if (date.includes("-")) {
          // }
          // 精确天的计算

          if (
            postDataPc.year === pcSelctData[0].options[0] &&
            postDataPc.month ===
            pcSelctData[1].options[pcSelctData[1].options.length - 1]
          ) {
            pcSelctData[2].options = currentdays.filter(
              (item) => item <= getDate
            );
          } else if (
            postDataPc.year ===
            pcSelctData[0].options[pcSelctData[0].options.length - 1] &&
            postDataPc.month === pcSelctData[1].options[0]
          ) {
            let _days = currentdays.filter((item3) => item3 > getDate);
            pcSelctData[2].options = _days;
          } else {

            let yearLast = last(pcSelctData[0].options);
            let yearFirst = first(pcSelctData[0].options);
            pcSelctData[2].options = currentdays;
            if (postDataPc.year == yearLast && postDataPc.month == getMonth) {
              pcSelctData[2].disabledDate = 'before';
            } else if (postDataPc.year == yearFirst && postDataPc.month == getMonth) {
              pcSelctData[2].disabledDate = 'after';
            } else {
              //  天数
              pcSelctData[2].disabledDate = false;
            }
          }
          sessionStorage.setItem("_days", JSON.stringify(pcSelctData[2].options));
        }

      } else if (item.type === "day") {
        postDataPc.day = e;
      }
    }


    let newPostData = Object.values(postDataPc).join("-");
    if (info.ageType === 1) {
      newPostData = postDataPc.year;
    } else if (info.ageType === 2) {
      let month2 = postDataPc.month ? postDataPc.month : pcSelctData[1].value;
      newPostData = postDataPc.year + "-" + month2 || "";
    } else if (info.ageType === 3) {
      let month3 = postDataPc.month ? postDataPc.month : pcSelctData[1].value;
      let days3 = postDataPc.day ? postDataPc.day : pcSelctData[2].value;

      newPostData =
        postDataPc.year + "-" + (month3 || "") + "-" + (days3 || "");
    } else {
      newPostData = "";
    }
    let postData = {
      [currentItemObj.id]: {
        text: newPostData,
      },
    };

    pcSelctData[index].value = e;

    setpcSelctData((e) => {
      return [...pcSelctData];
    });
    changeAnswer(postData, postDataPc);
  };

  if (isMobile) {

    console.log('currentItemObjcurrentItemObj', currentItemObj);
    // let maxDate = currentItemObj.maxDate
    //   ? moment(dateFromt(currentItemObj.maxDate)).unix() * 1000
    //   : Date.parse(new Date());
    // let minDate = currentItemObj.minDate
    //   ? moment(dateFromt(currentItemObj.minDate)).unix() * 1000
    //   : Date.parse(new Date());
    return (
      <div className="age">
        <div className="q-content">
          <div className="q-content-options">
            <div className="q-content-options-describe">
              {language().age_range}
            </div>
            <>
              <DatePicker
                mode={DATEPICKERTYPE[info.ageType]}
                value={dpValue}
                visible={visible}
                maxDate={info.ageType == 1 ? new Date(+currentItemObj.maxDate, 1, 1, 0, 0, 0) :
                  info.ageType == 2 ? new Date(+currentItemObj.maxDate, new Date().getMonth(), 1, 0, 0, 0) :
                    new Date(+currentItemObj.maxDate, new Date().getMonth(), new Date().getDate(), 0, 0, 0)}


                minDate={info.ageType == 1 ? new Date(+currentItemObj.minDate, 1, 1, 0, 0, 0) :
                  info.ageType == 2 ? new Date(+currentItemObj.minDate, new Date().getMonth() + 1, 1, 0, 0, 0) :
                    new Date(+currentItemObj.minDate, new Date().getMonth(), new Date().getDate() + 1, 0, 0, 0)}
                onValueChange={(vals, index) => {

                  console.log(vals, index);
                }}
                onOk={(date) => {
                  const postData = {
                    [currentItemObj.id]: {
                      text: moment(date).format(FORMATTYPE[info.ageType]),
                    },
                  };
                  changeAnswer(
                    postData,
                    moment(date).format(FORMATTYPE[info.ageType])
                  );
                  setdpValue(date);
                  setVisible(false);
                }}
                onDismiss={() => setVisible(false)}
              />
              {_info.options.map((item, index) => {
                let listSelct = calculateAge(
                  item.ageDescription,
                  _info.ageType
                );
                if (_info.ageType == 1) {
                  if (listSelct.length > 0) {
                    item.minDate = last(listSelct);
                    item.maxDate = first(listSelct);
                  }

                } else if (_info.ageType == 2) {
                  item.minDate = last(listSelct);
                  item.maxDate = first(listSelct);
                } else {
                  item.minDate = last(listSelct);
                  item.maxDate = first(listSelct);
                }



                return (
                  <div
                    className="q-content-options-box"
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr auto",
                      gridTemplateRows: "20px",
                      alignItems: "center",
                      padding: "10px",
                      margin: "10px",

                      borderRadius: "2px",
                      backgroundColor: "#ebeef2",
                    }}
                    key={item.id}
                    onClick={() => {
                      const postData = {
                        [item.id]: {
                          text: "",
                        },
                      };
                      if (!isChina(item.ageDescription)) {
                        changeAnswer(postData, "no");
                      } else {
                        changeAnswer(postData, "clear");
                        setVisible(true);
                      }
                      setdpValue("");
                      onRadioClick(item.ageDescription, index, item);
                    }}
                  >
                    <Radio
                      className="radio-span"
                      value={item.ageDescription}
                      checked={_info.isRadio === item.ageDescription}
                      style={{
                        width: "100%",
                      }}
                    >
                      <span
                        style={{ flex: 1 }}
                        dangerouslySetInnerHTML={{
                          __html: getAgeMatch(item.ageDescription, 0),
                        }}
                      ></span>
                    </Radio>
                    {/* {JSON.stringify(dpValue)} */}

                    {!visible &&
                      _info.isRadio === item.ageDescription &&
                      item.relationDate === 1 &&
                      dpValue &&
                      moment(dpValue).format(FORMATTYPE[info.ageType])}
                  </div>
                );
              })}
            </>
          </div>
        </div>
      </div>
    );
  } else {

    return (
      <div className="age">
        <div className="q-content">
          <div className="q-content-options">
            <div
              className="q-content-options-describe"
              style={{ display: "grid" }}
            >
              {language().age_range}
            </div>
            <>
              {_info.options.filter((item) => item.hide !== 1).map((item, index) => {
                console.log(item)
                let listSelct = calculateAge(
                  item.ageDescription,
                  _info.ageType
                );

                if (listSelct.length > 0) {
                  if (listSelct[0] === moment().year()) {
                    item.maxDate = `${listSelct[0]},${moment().month() + 1
                      },${moment().date()}`;
                  } else {
                    item.maxDate = `${listSelct[0]},12,31`;
                  }
                  item.minDate = `${listSelct[listSelct.length - 1]}`;
                }
                return (
                  <>
                    <Radio
                      key={index}
                      className={"radio-box"}
                      value={item.ageDescription}
                      checked={currentItemObj.id == item.id}
                      onChange={(e) => {
                        options.forEach((item) => {
                          if (item.ageDescription === e.target.value) {
                            item.isRadio = true;
                          } else {
                            item.isRadio = false;
                          }
                        });
                        const postData = {
                          [item.id]: {
                            text: "",
                          },
                        };
                        if (!isChina(item.ageDescription)) {
                          changeAnswer(postData, "no");
                        } else {
                          changeAnswer(postData, "clear");
                        }
                        setpostDataPc({
                          year: "",
                          month: "",
                          day: "",
                        });
                        setOlddate([]);
                        setcurrentItemObj({ ...item });
                      }}
                    >
                      <span
                        dangerouslySetInnerHTML={{
                          __html: getAgeMatch(item.ageDescription, 0),
                        }}
                      ></span>
                    </Radio>
                  </>

                );
              })}

              {currentItemObj.relationDate === 1 ? (
                <>
                  <div className="q-content-option-hide" style={{}}>
                    {null ? "" : showSelcetDate(pcSelctData)}
                  </div>
                  <div>
                    {pcSelctData.map((item, index) => {
                      return (
                        item.isshow && (
                          <Select
                            key={index}
                            style={{ minWidth: 160, margin: "10px" }}
                            value={item.value}
                            placeholder={item.defaultValue}
                            onChange={(e) => {
                              _onChange(e, index, item, 1);
                            }}
                          >
                            {(item.options || []).map((item2, index2) => {
                              return (
                                <Option key={index2} value={item2} disabled={disabledDateFn(item2, item.disabledDate)} >
                                  {item2}
                                </Option>
                              );
                            })}
                          </Select>
                        )
                      );
                    })}
                  </div>
                </>
              ) : null}
            </>
          </div>
        </div>
      </div>
    );
  }
}
// item2,item.disabledDate
function disabledDateFn(dy, type) {
  // before  after
  if (type == "before") {
    return dy <= new Date().getDate()
  }
  if (type == "after") {
    return dy > new Date().getDate()
  }
  return false

}
//计算年龄
function calculateAge(strValue, type) {

  if (type == 1) {
    return calculateAgeYear(strValue, type)
  } else if (type == 2) {
    return calculateAgeMonth(strValue, type)
  } else {
    return calculateAgeDay(strValue, type)
  }

}

// 计算对应pc 展示的年
function calculateAgeYear(strValue, type) {
  if (!strValue) return [];
  // strValue = strValue.replace("<p>", "").replace("</p>", "");
  let _date = new Date();
  let _year = _date.getFullYear();
  if (strValue !== null && strValue !== "") {
    const reg = /[\u4e00-\u9fa5]/g;
    const arrayAge = [];
    if (strValue.includes("&gt;")) {
      // let _age = strValue.replace(reg, "");
      let _age = getAgeMatch(strValue, 1);

      if (strValue.includes("&gt;=")) {
        for (let index = 0; index <= 100 - _age; index++) {
          arrayAge.push(+_year - _age - index);
        }
      } else {
        for (let index = 0; index <= 100 - _age; index++) {
          arrayAge.push(+_year - 1 - _age - index);
        }
      }
    } else if (strValue.includes("&lt;")) {
      // let _age = strValue.replace(reg, "");
      let _age = getAgeMatch(strValue, 1);
      if (strValue.includes(strValue.includes("&lt;="))) {
        _age = Number(_age) + 1;
        for (let index = 0; index < _age; index++) {
          arrayAge.push(_year - index);
        }
      } else {
        _age = Number(_age);
        for (let index = 0; index < _age; index++) {
          arrayAge.push(_year - index);
        }
      }
    } else if (strValue.includes("-")) {

      // let _age = strValue.replace(reg, "").split("-");
      let _age = getAgeMatch(strValue, 3);

      if (type === 2 || type === 3) {
        _age[1] = Number(_age[1]) + 1;
      }
      for (let index = 0; index <= _age[1] - _age[0]; index++) {
        arrayAge.push(_year - _age[0] - index);
      }

    }

    if (_date.getMonth() + 1 === 12 && type === 2) {
      arrayAge.pop();
    }
    return arrayAge;
  }
}
// 计算对应pc 展示的年月日

function calculateAgeMonth(strValue, type) {
  if (!strValue) return [];
  // strValue = strValue.replace("<p>", "").replace("</p>", "");
  let _date = new Date();
  let _year = _date.getFullYear();

  if (strValue !== null && strValue !== "") {
    const reg = /[\u4e00-\u9fa5]/g;
    const arrayAge = [];
    if (strValue.includes("&gt;")) {
      // let _age = strValue.replace(reg, "");
      let _age = getAgeMatch(strValue, 1);
      if (strValue.includes("&gt;=")) {
        for (let index = 0; index <= 100 - _age; index++) {
          arrayAge.push(+_year - _age - index);
        }
      } else {
        for (let index = 0; index <= 100 - _age; index++) {
          arrayAge.push(+_year - 1 - _age - index);
        }
      }
    } else if (strValue.includes("&lt;")) {
      // let _age = strValue.replace(reg, "");
      let _age = getAgeMatch(strValue, 1);
      if (strValue.includes("&lt;=")) {
        _age = Number(_age) + 1;
        for (let index = 0; index <= _age; index++) {
          arrayAge.push(_year - index);
        }
      } else {
        _age = Number(_age) + 1;
        for (let index = 0; index < _age; index++) {
          arrayAge.push(_year - index);
        }
      }
    } else if (strValue.includes("-")) {

      let _age = getAgeMatch(strValue, 3);
      // let _age = strValue.replace(reg, "").split("-");
      if (type === 2) {
        _age[1] = Number(_age[1]) + 1;
      }
      for (let index = 0; index <= _age[1] - _age[0]; index++) {
        arrayAge.push(_year - _age[0] - index);
      }

      if (_date.getMonth() + 1 === 12 && type === 2) {
        arrayAge.pop();
      }
    }

    if (_date.getMonth() + 1 === 12 && type === 2) {
      arrayAge.pop();
    }
    return arrayAge;
  }
}
// 计算对应pc 展示的年月日

function calculateAgeDay(strValue, type) {
  console.log(strValue);
  if (!strValue) return [];
  // strValue = strValue.replace("<p>", "").replace("</p>", "");
  let _date = new Date();
  let _year = _date.getFullYear();

  if (strValue !== null && strValue !== "") {
    const reg = /[\u4e00-\u9fa5]/g;
    const arrayAge = [];
    //  以上
    if (strValue.includes("&gt;")) {
      let _age = getAgeMatch(strValue, 1);
      if (strValue.includes("&gt;=")) {
        for (let index = 0; index <= 100 - _age; index++) {
          arrayAge.push(+_year - _age - index);
        }
      } else {
        for (let index = 0; index <= 100 - _age; index++) {
          arrayAge.push(+_year - 1 - _age - index);
        }
      }
    } else if (strValue.includes("&lt;")) {// 以下
      let _age = getAgeMatch(strValue, 1);
      if (strValue.includes("&lt;=")) {
        _age = Number(_age) + 1;
        for (let index = 0; index <= _age; index++) {
          arrayAge.push(_year - index);
        }
      } else {
        _age = Number(_age) + 1;
        for (let index = 0; index < _age; index++) {
          arrayAge.push(_year - index);
        }
      }
    } else if (strValue.includes("-")) {
      let _age = getAgeMatch(strValue, 3);
      if (type === 2 || type === 3) {
        _age[1] = Number(_age[1]) + 1;
      }
      for (let index = 0; index <= _age[1] - _age[0]; index++) {
        arrayAge.push(_year - _age[0] - index);
      }
    }
    if (_date.getMonth() + 1 === 12 && type === 2) {
      arrayAge.pop();
    }
    return arrayAge;
  }
}
// JS根据年月获得当月天数的实现代码;
function getDaysInMonth(year, month) {
  month = parseInt(month, 10); //parseInt(number,type)这个函数后面如果不跟第2个参数来表示进制的话，默认是10进制。
  let temp = new Date(year, month, 0).getDate();
  let day = [];

  for (let index = 0; index < +temp; index++) {
    day.push(index + 1);
  }
  return day;
}

function isChina(str) {
  var reg = /\d/;

  return reg.test(str);
}
// js根据年和月获取当月的天数
function getDaysInMonth2(year, month) {
  month = parseInt(month, 10); //parseInt(number,type)这个函数后面如果不跟第2个参数来表示进制的话，默认是10进制。
  var temp = new Date(year, month, 0);
  return temp.getDate();
}


//  处理时间

function dateFromt(str) {
  let date1 = str.split('-');

  return date1[0] + '-' + date1[1].padStart(2, '0') + '-' + date1[2].padStart(2, '0')
}
//  date1.forEach((element,index) => {
//    let date2= '';
//        if(element<=9){
//         date2 =  '0'+element
//         newDate =newDate+date2
//        }else{
//         newDate =newDate+element
//        }
//   });

function showSelcetDate(list) {

  let _list = list.filter(item => item.isshow)

  if (_list.length == 1) {
    return language().select_year
  }
  if (_list.length == 2) {
    return language().select_year_month
  }
  if (_list.length == 3) {
    return language().select_date
  }

  return language().select_date

}




function getDayNumByYearMonth(year, month) {
  switch (+month) {
    case 1:
    case 3:
    case 5:
    case 7:
    case 8:
    case 10:
    case 12:
      return 31;
      break;
    case 4:
    case 6:
    case 9:
    case 11:
      return 30;
      break;
    case 2:
      return isLeapYear(year) ? 29 : 28;
  }
}
function isLeapYear(year) {
  if (year / 4 == 0 && year / 100 != 0) {
    return true;
  } else if (year / 400 == 0) {
    return true;
  } else {
    return false;
  }
}

function DatePickerTypeMax(ageType, date) {

  if (!date) {
    return ''
  }
  if (ageType == 1) {
    return new Date(+date, 1, 1, 0, 0, 0)
  }
  return new Date(date, 1, 1, 0, 0, 0)

}

function getAgeMatch(str, type) {
  console.log(str);
  if (!str) return '--'
  const separatorRegex = /<p>======<\/p>/;
  const parts = str.split(separatorRegex);
  const regex = /\((.*?)\)/;
  if (parts.length == 2) {
    const result = parts[1].match(regex);
    if (type == 1) {
      if (result[1].includes('-')) {
        return result[1]
      } else {
        const regex = /\d+/;
        const result2 = result[1].match(regex);
        return result2[0]
      }
    } else if (type == 2) {
      return result[1]
    } else if (type == 3) {
      return result[1].split('-')
    } else {
      return parts[0]
    }
  }
  return [str, str]
}
